import React from "react";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import ButtonGroup from "../elements/ButtonGroup";
import Button from "../elements/Button";
import Image from "../elements/Image";
//import Modal from "../elements/Modal";
import GoogleMapReact from "google-map-react";
import { Link } from "react-router-dom";

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  // const [videoModalActive, setVideomodalactive] = useState(false);

  // const openModal = (e) => {
  //   e.preventDefault();
  //   setVideomodalactive(true);
  // };

  // const closeModal = (e) => {
  //   e.preventDefault();
  //   setVideomodalactive(false);
  // };

  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "hero-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const AnyReactComponent = ({ text }) => (
    <div>
      <Image
        src={require("../../assets/images/pin.svg")}
        alt="Marker"
        width={32}
        height={32}
      />
      <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
        Okršaj bb 51218, Dražice
      </div>
    </div>
  );

  return (
    <section {...props} className={outerClasses}>
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1
              className="mt-0 mb-16 reveal-from-bottom"
              data-reveal-delay="200"
            >
              Šahovski Klub <span className="text-color-primary">Rječina</span>
            </h1>
            <div className="container-xs">
              <p
                className="m-0 mb-32 reveal-from-bottom"
                data-reveal-delay="400"
              >
                Dobrodošli na stranicu šahovskog kluba Rječina koji se nalazi u
                općini Jelenje. Ovdje možete saznati više o klubu, njegovim
                članovima, novosti te informacije o održanim turnirima. Šahovski
                klub Rječina - Dražice počeo je djelovati u jesen 1999. na
                inicijativu Gorana Mufića i Ljube Kukuljana, a službeno je
                osnovan 21.02.2000. godine.
              </p>
              <div className="reveal-from-bottom" data-reveal-delay="600">
                <ButtonGroup>
                  <Button color="primary" wideMobile>
                    <Link to="/novosti">Novosti</Link>
                  </Button>
                  <Button color="dark" wideMobile>
                    <Link to="/o-nama">O Nama</Link>
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          </div>
          <div
            className="hero-figure reveal-from-bottom illustration-element-01"
            data-reveal-value="20px"
            data-reveal-delay="800"
          >
            <div style={{ height: "40vh", width: "100%" }}>
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: "AIzaSyDSqXdQFQXLYXvXZmhHh90cUCKgz46mVzg",
                }}
                defaultCenter={{
                  lat: 45.385615606113106,
                  lng: 14.463052305200739,
                }}
                defaultZoom={14}
              >
                <AnyReactComponent
                  lat={45.385615606113106}
                  lng={14.463052305200739}
                  text="My Marker"
                />
              </GoogleMapReact>
            </div>
            {/* <a
              data-video="https://player.vimeo.com/video/174002812"
              href="#0"
              aria-controls="video-modal"
              onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require("./../../assets/images/video-placeholder.jpg")}
                alt="Hero"
                width={896}
                height={504}
              />
            </a> */}
          </div>
          {/* <Modal
            id="video-modal"
            show={videoModalActive}
            handleClose={closeModal}
            video="https://player.vimeo.com/video/174002812"
            videoTag="iframe"
          /> */}
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
